import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/partials/header/header.component';
import { HomeComponent } from './components/pages/home/home.component';
import { AppRoutingModule } from './/app-routing.module';
import { TitleComponent } from './components/partials/title/title.component';
import { NotFoundComponent } from './components/partials/not-found/not-found.component';
import { LoginPageComponent } from './components/pages/login-page/login-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InputContainerComponent } from './components/partials/input-container/input-container.component';
import { InputValidationComponent } from './components/partials/input-validator/input-validation.component';
import { TextInputComponent } from './components/partials/text-input/text-input.component';
import { DefaultButtonComponent } from './components/partials/default-button/default-button.component';
import { LoadingComponent } from './components/partials/loading/loading.component';
//import { LoadingInterceptor } from './shared/interceptors/loading.interceptor';
import { UserPageComponent } from './components/pages/user-page/user-page.component';
import { ListUserPageComponent } from './components/pages/list-user-page/list-user-page.component';
import { ListTankPageComponent } from './components/pages/list-tank-page/list-tank-page.component';
import { TankPageComponent } from './components/pages/tank-page/tank-page.component';
import { FuelPageComponent } from './components/pages/fuel-page/fuel-page.component';
import { ListFuelPageComponent } from './components/pages/list-fuel-page/list-fuel-page.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { VehiclePageComponent } from './components/pages/vehicle-page/vehicle-page.component';
import { ListVehiclePageComponent } from './components/pages/list-vehicle-page/list-vehicle-page.component';
import { ListChargesPageComponent } from './components/pages/list-charges-page/list-charges-page.component';
import { ChargePageComponent } from './components/pages/charge-page/charge-page.component';
import { DatePipe } from '@angular/common';
import { ListVoucherPageComponent } from './components/pages/list-voucher-page/list-voucher-page.component';
import { VoucherPageComponent } from './components/pages/voucher-page/voucher-page.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DatepickerRangeComponent } from './components/partials/datepicker-range/datepicker-range.component';
import { ListDischargePageComponent } from './components/pages/list-discharge-page/list-discharge-page.component';
import { DischargePageComponent } from './components/pages/discharge-page/discharge-page.component';
import { AlertPageComponent } from './components/partials/alert-page/alert-page.component';
import { KeyboardComponent } from './components/partials/keyboard/keyboard.component';
import { KeyboardService } from './services/keyboard.service';
import { OskInputDirective } from './shared/directives/osk-input.directive';
import { KeyboardKeyDirective } from './shared/directives/keyboard-key.directive';
import { PumpPageComponent } from './components/pages/pump-page/pump-page.component';
import { VehiclePopupComponent } from './components/partials/vehicle-popup/vehicle-popup.component';
import { OskNumberinputDirective } from './shared/directives/osk-numberinput.directive';
import { NumberInputComponent } from './components/partials/number-input/number-input.component';
import { VoucherFilterComponent } from './components/partials/voucher-filter/voucher-filter.component';
import { DischargeFilterComponent } from './components/partials/discharge-filter/discharge-filter.component';
import { PrintVoucherPageComponent } from './components/pages/print-voucher-page/print-voucher-page.component';
import { WebAccessDisabledPageComponent } from './components/pages/web-access-disabled-page/web-access-disabled-page.component';
import { PaginationModule } from 'ngx-bootstrap/pagination';




@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    TitleComponent,
    NotFoundComponent,
    LoginPageComponent,
    InputContainerComponent,
    InputValidationComponent,
    TextInputComponent,
    DefaultButtonComponent,
    LoadingComponent,
    UserPageComponent,
    ListUserPageComponent,
    ListTankPageComponent,
    TankPageComponent,
    FuelPageComponent,
    ListFuelPageComponent,
    VehiclePageComponent,
    ListVehiclePageComponent,
    ListChargesPageComponent,
    ChargePageComponent,
    ListVoucherPageComponent,
    VoucherPageComponent,
    DatepickerRangeComponent,
    ListDischargePageComponent,
    DischargePageComponent,
    AlertPageComponent,
    KeyboardComponent,
    OskInputDirective,
    KeyboardKeyDirective,
    PumpPageComponent,
    VehiclePopupComponent,
    OskNumberinputDirective,
    NumberInputComponent,
    VoucherFilterComponent,
    DischargeFilterComponent,
    PrintVoucherPageComponent,
    WebAccessDisabledPageComponent,

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    PaginationModule.forRoot(),
    NgbModule.forRoot(),
    ReactiveFormsModule,
    NgMultiSelectDropDownModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
      newestOnTop: false
    })

  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    DatePipe, KeyboardService,
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }
